import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { getFeaturedExcursions } from '../data/excursions';

// Homepage "Excursions & Day Trips" section — replaces the old Popular Destinations.
// Cards use a branded gradient until client photos land (then images[0] is used).
const FeaturedExcursions = () => {
  const excursions = getFeaturedExcursions(3);

  return (
    <div className="py-20 bg-eggshell">
      <div className="container mx-auto px-4">
        <div className="max-w-xl mx-auto text-center mb-16">
          <div className="flex items-center justify-center mb-4">
            <div className="h-1 w-12 bg-hunyadi-yellow mr-4"></div>
            <p className="text-clay text-xs font-medium uppercase tracking-[0.22em]">Excursions &amp; Day Trips</p>
            <div className="h-1 w-12 bg-hunyadi-yellow ml-4"></div>
          </div>
          <h2 className="text-4xl md:text-5xl font-light mb-6 text-cafe-noir tracking-tight">Unforgettable Experiences</h2>
          <p className="text-cafe-noir text-lg">Handpicked day trips and excursions across Kenya — from coastal dhow sails to city safaris and cultural encounters.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {excursions.map((ex) => (
            <div
              key={`${ex.locationSlug}-${ex.slug}`}
              className="group relative overflow-hidden h-[500px] rounded-2xl shadow-xl flex flex-col"
            >
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
                style={ex.images && ex.images[0] ? { backgroundImage: `url(${ex.images[0]})` } : undefined}
              >
                {!(ex.images && ex.images[0]) && (
                  <div className="absolute inset-0 bg-gradient-to-br from-moss-green to-cafe-noir"></div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/20"></div>
              </div>

              <div className="relative z-10 text-white flex flex-col justify-end h-full p-8">
                <div className="space-y-4">
                  <div className="flex justify-between items-center gap-2">
                    <span className="bg-white/20 backdrop-blur-sm px-4 py-1 rounded-full text-sm font-medium">
                      {ex.category}
                    </span>
                    <span className="bg-hunyadi-yellow px-4 py-1 rounded-full text-sm font-medium text-cafe-noir whitespace-nowrap">
                      {ex.startingPrice != null ? `From ${ex.currency} ${ex.startingPrice}` : 'Enquire'}
                    </span>
                  </div>

                  <h3 className="text-2xl font-bold">{ex.title}</h3>
                  <p className="text-white/90 mb-2">{ex.location} · {ex.teaser}</p>

                  <Link
                    to={`/excursions/${ex.locationSlug}/${ex.slug}`}
                    className="w-full bg-white text-cafe-noir py-3 rounded-full hover:bg-cornsilk transition-colors font-medium inline-flex items-center justify-center group"
                  >
                    View details
                    <ArrowRight className="ml-2 transform group-hover:translate-x-1 transition-transform" size={18} />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/excursions"
            className="bg-transparent border border-cafe-noir hover:bg-cafe-noir hover:text-white text-cafe-noir px-8 py-3 rounded-full font-medium transition inline-flex items-center group cursor-pointer"
          >
            View All Excursions
            <ArrowRight className="ml-2 transform group-hover:translate-x-1 transition-transform" size={18} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FeaturedExcursions;
